import { TrendingUp, TrendingDown, Minus } from 'lucide-react'

interface StatusIconProps {
  completion: number
  className?: string
}

export function StatusIcon({ completion, className = 'w-4 h-4' }: StatusIconProps) {
  if (completion >= 100) return <TrendingUp className={className} />
  if (completion >= 80) return <Minus className={className} />
  return <TrendingDown className={className} />
}
